import { useState } from 'react'
import { Play } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import type { CollectionInfo, QueryRequest } from '../types/mongoConsole.types'

interface Props {
  collection: CollectionInfo
  onQuery: (req: QueryRequest) => void
  isLoading: boolean
}

export function QueryPanel({ collection, onQuery, isLoading }: Props) {
  const [filter, setFilter] = useState('')
  const [projection, setProjection] = useState('')
  const [sort, setSort] = useState('')
  const [limit, setLimit] = useState(20)
  const [skip, setSkip] = useState(0)

  const handleQuery = () => {
    onQuery({
      database: collection.database,
      collection: collection.name,
      filter: filter.trim() || undefined,
      projection: projection.trim() || undefined,
      sort: sort.trim() || undefined,
      limit,
      skip,
    })
  }

  return (
    <div className="border-b p-4 space-y-3">
      <div className="grid grid-cols-1 gap-2 md:grid-cols-3">
        <div>
          <label className="text-xs font-medium text-gray-500 mb-1 block">Filter (JSON)</label>
          <Input
            value={filter}
            onChange={e => setFilter(e.target.value)}
            placeholder='{"accountId": "123"}'
            className="font-mono text-xs h-8"
          />
        </div>
        <div>
          <label className="text-xs font-medium text-gray-500 mb-1 block">Projection (JSON)</label>
          <Input
            value={projection}
            onChange={e => setProjection(e.target.value)}
            placeholder='{"_id": 1, "name": 1}'
            className="font-mono text-xs h-8"
          />
        </div>
        <div>
          <label className="text-xs font-medium text-gray-500 mb-1 block">Sort (JSON)</label>
          <Input
            value={sort}
            onChange={e => setSort(e.target.value)}
            placeholder='{"createdAt": -1}'
            className="font-mono text-xs h-8"
          />
        </div>
      </div>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <label className="text-xs font-medium text-gray-500">Limit</label>
          <Input
            type="number" min={1} max={100} value={limit}
            onChange={e => setLimit(Number(e.target.value))}
            className="w-20 h-8 text-xs"
          />
        </div>
        <div className="flex items-center gap-2">
          <label className="text-xs font-medium text-gray-500">Skip</label>
          <Input
            type="number" min={0} value={skip}
            onChange={e => setSkip(Number(e.target.value))}
            className="w-20 h-8 text-xs"
          />
        </div>
        <Button size="sm" onClick={handleQuery} disabled={isLoading} className="ml-auto">
          <Play className="h-3.5 w-3.5 mr-1.5" />
          {isLoading ? 'Running…' : 'Run Query'}
        </Button>
      </div>
    </div>
  )
}
